/**
 * ytTheme.js — YouTube-flavored design tokens for RotoTube.
 *
 * RotoTube is re-skinned to read like youtube.com (dark mode): near-black page,
 * #272727 hover/chip surfaces, white/gray type, red accent. Centralized here so
 * the page, cards, chips, and player stay consistent.
 */

export const YT = {
  bg: '#0f0f0f',
  surface: '#212121',
  surfaceHover: '#272727',
  chip: '#272727',
  chipHover: '#3d3d3d',
  chipSelectedBg: '#f1f1f1',
  chipSelectedText: '#0f0f0f',
  border: '#303030',
  text: '#f1f1f1',
  textSecondary: '#aaaaaa',
  accent: '#ff0000',
};

// Format seconds → m:ss / h:mm:ss for the thumbnail duration badge.
export function fmtDuration(sec) {
  if (!sec) return '';
  const s = Math.round(sec);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  return h
    ? `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`
    : `${m}:${String(r).padStart(2, '0')}`;
}
